import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';

/**
 * Build a query-op request URL for `resourcePath`, optionally appending `path`.
 *
 * @param identifierType  WarpDrive identifier type (e.g. `'jira'`)
 * @param resourcePath    Base resource path (e.g. `'api/v2/jira'`)
 * @param path            Optional sub-path. May start with `/`, may be a bare
 *                        segment (`'overview'`), or a query string (`'?q=…'`).
 *                        The helper normalizes joining for all three forms.
 */
export function buildQueryRequestUrl(identifierType: string, resourcePath: string, path?: string) {
  const urlOptions: QueryUrlOptions = {
    identifier: { type: identifierType },
    op: 'query',
    resourcePath,
  };
  const baseUrl = buildBaseURL(urlOptions);

  if (!path) return baseUrl;
  if (path.startsWith('?')) return `${baseUrl}${path}`;
  return `${baseUrl}/${path.replace(/^\/+/, '')}`;
}
